module.exports = __webpack_public_path__ + "static/img/img-logo-hik-parahyangan.905cacf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing_page/img-logo-hik-parahyangan.png
// module id = DVRD
// module chunks = 36